import {ErrorComponent, ErrorComponentProps} from "@tanstack/react-router";

const isModuleNotFoundError = (error: Error): boolean =>
  typeof error?.message === "string" &&
  /Failed to fetch dynamically imported module/.test(error.message);

/**
 * Router error component for displaying errors that occur during routing.
 */
export const RouterError = ({error}: ErrorComponentProps) => {
  // Ignore module not found errors.
  if (isModuleNotFoundError(error)) return <div />;

  return <ErrorComponent error={error} />;
};
